export default __webpack_public_path__ + "static/media/icon-filter-funnel.ec21cb3b.svg";